module.exports = __webpack_public_path__ + "img/figure-4.db3492d4.png";